<template>
  <v-layout
    row
    justify-start
    align-center
  >
    <v-tooltip bottom>
      <v-btn
        v-if="showActions"
        class="ma-0"
        color="grey darken-1"
        slot="activator"
        @click="toggleFolderDownloadDialog(true)"
        icon
        flat
      >
        <v-icon>mdi-folder-download mdi-18px</v-icon>
      </v-btn>
      <span>Baixar Processo</span>
    </v-tooltip>

    <v-tooltip bottom v-if="showActions">
      <v-btn
        class="ma-0"
        color="grey darken-1"
        slot="activator"
        @click="toggleDocumentSearch"
        icon
        flat
      >
        <v-icon>mdi-file-find mdi-18px</v-icon>
      </v-btn>
      <span>Buscar Documento</span>
    </v-tooltip>

    <v-tooltip
      v-if="showActions"
      bottom
    >
      <v-btn
        class="ma-0"
        color="grey darken-1"
        slot="activator"
        @click="updateViewMode('list')"
        flat
        icon
      >
        <v-icon>mdi-view-list mdi-18px</v-icon>
      </v-btn>
      <span>Exibir em Lista</span>
    </v-tooltip>

    <v-tooltip
      v-if="showActions"
      bottom
    >
      <v-btn
        class="ma-0"
        color="grey darken-1"
        slot="activator"
        @click="updateViewMode('grid')"
        flat
        icon
      >
        <v-icon>mdi-view-grid mdi-18px</v-icon>
      </v-btn>
      <span>Exibir em Grid</span>
    </v-tooltip>

    <v-tooltip bottom v-if="showActions">
      <v-btn
        class="ma-0"
        color="grey darken-1"
        slot="activator"
        @click="updateViewMode('presentation')"
        icon
        flat
      >
        <v-icon>mdi-file-presentation-box mdi-18px</v-icon>
      </v-btn>
      <span>Modo Apresentação</span>
    </v-tooltip>

    <v-text-field
      v-show="showSearch && !showActions"
      class="search-field"
      prepend-inner-icon="search"
      :background-color="searchIsFocused ? 'white' : 'secondary'"
      placeholder="Buscar documento"
      @keyup="searchDocument($event)"
      solo
      :flat="!searchIsFocused"
      @focus="searchIsFocused = !searchIsFocused"
      @blur="searchIsFocused = !searchIsFocused"
      @click:append="toggleDocumentSearch"
      append-icon="mdi-close"
    />

    <folder-download-dialog
      :show="showFolderDownloadDialog"
      @toggleFolderDownloadDialog="toggleFolderDownloadDialog"
    />

  </v-layout>
</template>

<script>
import FolderDownloadDialog from '@/components/folder/show/toolbar/action/FolderDownloadDialog';

export default {
  name: 'ActionSecondary',
  components: {
    FolderDownloadDialog,
  },
  data() {
    return {
      showFolderDownloadDialog: false,
      showSearch: false,
      searchIsFocused: false,
    };
  },
  props: {
    showActions: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    folder() {
      return this.$store.getters.activeFolder;
    },
    folderViewMode() {
      return this.$store.getters.folderViewMode;
    },
  },
  methods: {
    toggleFolderDownloadDialog(bool) {
      this.showFolderDownloadDialog = bool;
    },
    updateViewMode(value) {
      this.$store.dispatch('FOLDER_VIEW_MODE', value);
    },
    toggleDocumentSearch() {
      if (this.showActions) {
        this.$emit('hideActions');
        this.showSearch = true;
      } else {
        this.$emit('showActions');
        this.showSearch = false;
        this.$emit('searchDocument', '');
      }
    },
    searchDocument(event) {
      this.$emit('searchDocument', event.target.value);
    },
  },
};
</script>

<style lang="scss">
  .folder-toolbar  {
    .search-field {
      .v-input__slot {
        border-radius: 24px !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/folder/show/toolbar/action/FolderSecondaryAction.vue